import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-white pt-16">
        <div className="flex justify-between w-full">
          {/* Login Field  */}
          <div className="w-full md:max-w-[80%] mx-auto">
            <div className="w-[60%] mx-auto">
              {/* Logo */}
              <div className="mb-16 md:mb-32 w-full md:w-4/5 mx-auto">
                <img src="assets/Logo.png" alt="Celma_logo" className="" />
              </div>

              {/* Login */}
              <div className="text-center mb-20">
                <h2 className="text-3xl md:text-32 font-bolder text-darkpurple mb-2">
                  Log in
                </h2>
                <p className="text-darkpurple mb-8 font-medium">
                  Log in to have access to your dashboard
                </p>
              </div>
              <form className="w-full md:w-4/5 mx-auto">
                <div className="mb-6">
                  <label className="block text-[#0B2239] mb-2 font-medium">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-purple"
                    placeholder="Email Address"
                    value={email}
                    onChange={(ev) => setEmail(ev.target.value)}
                  />
                </div>
                <div className="mb-6 relative">
                  <label className="block text-[#0B2239] mb-2 font-medium">
                    Password
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:border-purple"
                    placeholder="Password"
                    value={password}
                    onChange={(ev) => setPassword(ev.target.value)}
                  />
                  <i
                    className="absolute inset-y-8  right-0 px-4 py-2 text-[#1C1C1C]"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FaEye size={20} />
                    ) : (
                      <FaEyeSlash size={20} />
                    )}
                  </i>
                </div>
                <button
                  type="submit"
                  className="w-full bg-purple text-white py-3 hover:bg-purple transition duration-300 rounded-full"
                >
                  Sign In
                </button>
                <p className="text-[#404757] mt-4 text-center font-semibold">
                  Don't have an account?{" "}
                  <a href="#" className="underline font-bold">
                    Sign Up
                  </a>
                </p>
              </form>
            </div>
          </div>

          {/* Login Image */}
          <div className="w-[60%] max-h-screen hidden md:flex items-center justify-center border-purple">
            <img
              src="assets/signin_img.png"
              alt="user"
              className="w-full h-auto object-cover object-center"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
